module.exports = __webpack_public_path__ + "media/img/home/our-work/photo-2-c6308767489d44ba7ead968916518d07.webp";